const styles = theme => ({
  mainPaper: {
    height: '100%',
  },
  title: {
    marginTop: 20
  }
});

export default styles;